import Vue from "vue";
import CloudinaryImage from "@teamnovu/vue-cloudinary-image";

let options = JSON.parse(`{"cloudinaryBaseUrl":"https://res.cloudinary.com/atramex-ch/image/upload/"}`);

Vue.use(CloudinaryImage, {
  ...options,
});
